export const initializeRouteChangeHandler = (handleRouteChange: () => void) => {
    // Handle navigation link clicks
    const handleLinkClick = (e: MouseEvent) => {
        const link = e.target as HTMLElement;
        if (
            link.tagName === 'A' &&
            link.getAttribute('href')?.startsWith('/')
        ) {
            e.preventDefault();
            const href = link.getAttribute('href')!;
            history.pushState({}, '', href);
        }
    };

    // Initialize all event listeners when DOM is ready
    window.addEventListener('DOMContentLoaded', () => {
        // Handle initial route
        handleRouteChange();

        // Add click handler for navigation
        document.addEventListener('click', handleLinkClick);
    });

    // Handle URL changes (including back/forward navigation)
    window.addEventListener('popstate', handleRouteChange);

    // Handle hash changes
    window.addEventListener('hashchange', handleRouteChange);

    // Handle pushState and replaceState
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function (...args) {
        originalPushState.apply(this, args);
        handleRouteChange();
    };

    history.replaceState = function (...args) {
        originalReplaceState.apply(this, args);
        handleRouteChange();
    };
};
